import React from 'react';
import Meta from '../../components/Meta';
import fs from 'fs';
import path from 'path';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkHtml from 'remark-html';
import ReactMarkdownWithHtml from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

const Tarms = ({ content }) => {
	return (
		<div>
			<Meta title="Política de Privacidad" />
			<div className="pt-[5.5rem] lg:pt-24">
				{/* <!-- TOS --> */}
				<section className="dark:bg-jacarta-800 relative py-16 md:py-24">
					<picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
						<img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
					</picture>
					<div className="container">
						<h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
						Política de Privacidad
						</h1>
						<div className="article-content mx-auto max-w-[48.125rem]">
             				 <ReactMarkdownWithHtml 
                                components={{
                                    code({ node, className, children, ...props }) {
                                    const match = /language-(\w+)/.exec(className || '');
                                    return match ? (
                                        <SyntaxHighlighter
                                            style={dracula}
                                            language={match[1]}
                                            PreTag="div"
                                            {...props}
                                            >
                                            {String(children).replace(/\n$/, '')}
                                            </SyntaxHighlighter>
                                        ) : (
                                        <code className={className} {...props}>
                                        {children}
                                        </code>
                                    );
                                    },
                                }}
                                rehypePlugins={[rehypeRaw]}
                                >{content}</ReactMarkdownWithHtml>
					</div>
					</div>
				</section>
				{/* <!-- end TOS --> */}
			</div>
		</div>
	);
};

export default Tarms;

async function loadTermsContent() {
	const filePath = path.join(process.cwd(), 'pages/politicas-privacidad/politic.md');
	const fileContents = fs.readFileSync(filePath, 'utf8');
	const processedContent = await unified()
	  .use(remarkParse)
	  .use(remarkHtml)
	  .process(fileContents);
	return processedContent.toString();
  }
  
  export async function getStaticProps() {
	const content = await loadTermsContent();
	return { props: { content } };
  }